module.exports = __webpack_public_path__ + "img/new-banner-overlay.10b2491c.svg";